import useTrackNativePrintEvents from "./useTrackNativePrintEvents/useTrackNativePrintEvents";
import useTrackGtmAccountLogin from "./useTrackGtmAccountLogin/useTrackGtmAccountLogin";

const GlobalEventsHandler = () => {
  useTrackNativePrintEvents();
  useTrackGtmAccountLogin();
  return null;
};

export default GlobalEventsHandler;
